const danhSachNhomCongViec = (state) => state.danhSachNhomCongViec;

const chiTietNhomCongViec = (state) => state.chiTietNhomCongViec;

const danhSachMauDuThao = (state) => state.danhSachMauDuThao;

const chiTietMauDuThao = (state) => state.chiTietMauDuThao;

const chiTietNhomCongViecTrongHeThong = (state) =>
  state.chiTietNhomCongViecTrongHeThong;

const cauHinh = (state) => state.cauHinh;

const dongBoDanhMucChung = (state) => state.dongBoDanhMucChung;
const dongBoCanBo = (state) => state.dongBoCanBo;

const danhSachLinhVuc = (state) => state.danhSachLinhVuc;
const themLinhVuc = (state) => state.themLinhVuc
const getDanhSachPhongBan = (state) => state.danhSachPhongBan
const danhSachNopLuu = (state) => state.danhSachNopLuu
const danhSachUyQuyen = (state) => state.danhSachUyQuyen
const danhSachNguoiUyQuyen = (state) => state.danhSachNguoiUyQuyen


export default {
  danhSachNhomCongViec,
  chiTietNhomCongViec,
  danhSachMauDuThao,
  chiTietNhomCongViecTrongHeThong,
  chiTietMauDuThao,
  cauHinh,
  danhSachLinhVuc,
  themLinhVuc,
  getDanhSachPhongBan,
  danhSachNopLuu,
  danhSachUyQuyen,
  danhSachNguoiUyQuyen,
  dongBoDanhMucChung,
  dongBoCanBo,
};
